import { Suspense, lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useLocation } from 'react-router-dom';

import NotFound from '../pages/NotFound';
import Loading from './Loading';

const Home = lazy(() => import('../pages/home/Home'));
const Category = lazy(() => import('../pages/category/Category'));
const Product = lazy(() => import('../pages/product/Product'));
const Cart = lazy(() => import('../pages/checkout/Cart'));
const CheckoutForm = lazy(() => import('../pages/checkout/Checkout'));
const DeliveryForm = lazy(() => import('../pages/checkout/Delivery'));
const PaymentForm = lazy(() => import('../pages/checkout/Payment'));
const Summary = lazy(() => import('../pages/checkout/Summary'));
const Confirm = lazy(() => import('../pages/checkout/Confirm'));
const Cms = lazy(() => import('../pages/Cms'));
const Search = lazy(() => import('../pages/category/Search'));

function Router() {
    const { t } = useTranslation('urls');
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <Suspense fallback={<Loading />}>
            <Routes>
                <Route index element={<Home />} />
                <Route
                    path={`${t('category')}/:category`}
                    element={<Category />}
                />
                <Route path={`${t('buy')}/:product`} element={<Product />} />
                <Route path={`${t('cart')}`} element={<Cart />} />
                <Route path={`${t('checkout')}`} element={<CheckoutForm />} />
                <Route path={`${t('delivery')}`} element={<DeliveryForm />} />
                <Route path={`${t('payment')}`} element={<PaymentForm />} />
                <Route path={`${t('summary')}`} element={<Summary />} />
                <Route path={`${t('confirm')}`} element={<Confirm />} />
                <Route path={`${t('terms')}`} element={<Cms id={1} />} />
                <Route path={`${t('cookies')}`} element={<Cms id={2} />} />
                <Route path={`${t('privacy')}`} element={<Cms id={3} />} />
                <Route path={`${t('download')}`} element={<Cms id={4} />} />
                <Route path={`${t('search')}`} element={<Search />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    );
}

export default Router;
